import React from 'react';
import styled from 'styled-components';

import useTheme from '@rover/kibble/themes/useTheme';

type StyledLabelProps = {
  fontSize?: string;
  mb?: string;
  color?: string;
};

export const StyledLabel = styled.label<StyledLabelProps>`
  font-weight: 700;
  font-size: ${({ fontSize }) => fontSize || 'unset'};
  display: inline-flex;
  ${(props) => `
    color: ${props.color};
    margin-bottom: ${props.mb};
  `}
`;

export type Props = React.ComponentPropsWithoutRef<'label'> & StyledLabelProps;

const Label = ({ children, mb, color, ...other }: Props): JSX.Element => {
  const theme = useTheme();
  const defaultMb = mb || theme.space['2x'];
  const defaultColor = color || theme.textColor.secondary;

  return (
    <StyledLabel mb={defaultMb} color={defaultColor} {...other}>
      {children}
    </StyledLabel>
  );
};

export default Label;
